import React, { useState } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import EmpresaSelect from '../../../../components/catalogo/Empresa';
import apiInstance from '../../../../services/ServiceApi';

function LineaNegocioAdd() {
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [lineaNegocio, setLineaNegocio] = useState("");

    const handleEmpresaSelected = (empresa) => {
        setSelectedEmpresa(empresa);
    };

    const handleInputChange = (event) => {
        setLineaNegocio(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!selectedEmpresa) {
            alert("Por favor, seleccione una empresa.");
            return;
        }

        const dataToSend = {
            empresa: selectedEmpresa.id,
            linea_negocio: lineaNegocio
        };

        apiInstance.post('/lineasnegocio/', dataToSend)
            .then(response => {
                alert("Línea de negocio agregada exitosamente!");
                setLineaNegocio("");  // Limpiamos el input
            })
            .catch(error => {
                console.error("Error al agregar la línea de negocio:", error);
                alert("Error al agregar la línea de negocio.");
            });
    };

    return (
        <form onSubmit={handleSubmit}>
            <FormControl fullWidth margin="normal">
                <EmpresaSelect onEmpresaSelected={handleEmpresaSelected} />
            </FormControl>
            
            <FormControl fullWidth margin="normal">
                <TextField
                    label="Línea de Negocio"
                    variant="outlined"
                    value={lineaNegocio}
                    onChange={handleInputChange}
                />
            </FormControl>

            <Button 
                type="submit" 
                variant="contained" 
                color="primary"
                disabled={!selectedEmpresa || !lineaNegocio.trim()}  // El botón estará deshabilitado si no se ha seleccionado una empresa o la línea de negocio está vacía
            >
                Agregar Línea de Negocio
            </Button>

        </form>
    );
}

export default LineaNegocioAdd;
